// Libraries
import {
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import {
  ActivatedRoute,
  Router
} from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  Location
} from '@angular/common';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

// Services
import { Angular2TokenService } from 'angular2-token';

// Forms
import {
  FormUtils,
  WoopaValidators
} from './../../woopa-ui/forms';

/**
 * `ResetComponent` implements view to reset password.
 */
@Component({
  template: require('./reset.component.html')
})
export class ResetComponent implements OnInit, OnDestroy {
  /**
   * From group for reset password.
   */
  public resetForm: FormGroup;
  /**
   * Keep current form errors.
   */
  public formErrors = {
    'password': '',
    'confirmPassword': ''
  };

  /**
   * Store validation error messages.
   */
  public validationMessages = {
    'password': {
      'required': 'La nueva contraseña es requerida.'
    },
    'confirmPassword': {
      'required': 'La confirmacion es requerida.',
      'equalsTo': {
        'password': 'Las contraseñas no coinciden.'
      }
    }
  };
  /**
   * Flag to maintain if request is running or not.
   */
  public isLoading = false;
  /**
   * Reset errors.
   */
  public errors = [];
  /**
   * reset password token
   */
  public resetPasswordToken: string;
  /**
   * Success message flag
   */
  public successMessage = false;
  /**
   * Route params subscription.
   */
  private sub: any;

  /**
   * Creates a new `ResetComponent` instance.
   */
  constructor(
    private tokenService: Angular2TokenService,
    private fb: FormBuilder,
    private toastr: ToastsManager,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  /**
   * Implements on init method.
   */
  public ngOnInit(): void {
    this.buildForm();
    // Check query params
    this.sub = this.route.queryParams.subscribe(queryParams => {
      // Set reset password token
      this.resetPasswordToken = queryParams['reset_password_token'];
      // If token is invalid, navigate to login
      if (!this.resetPasswordToken) {
        this.router.navigate(['/login']);
      } else {
        // Clean url
        this.location.replaceState('login/reset');
        // Check if user is signed in
        if (this.tokenService.userSignedIn()) {
          // Sign out
          this.tokenService.signOut();
        }
      }
    });
  }

  /**
   * Implements on destroy method.
   */
  public ngOnDestroy() {
    this.sub.unsubscribe();
  }

  /**
   * Reset user password.
   */
  public reset(): any {
    // Do reset and redirect
    const formModel = this.resetForm.value;
    const params = {
      password: formModel.password,
      passwordConfirmation: formModel.confirmPassword,
      passwordCurrent: null,
      resetPasswordToken: this.resetPasswordToken
    };
    // Toggle loading flag
    this.isLoading = true;
    // Make reset
    this.tokenService.updatePassword(params).subscribe(
      () => {
        // Toggle loading flag
        this.isLoading = false;
        // Show message
        this.successMessage = true;
      },
      (res) => {
        const response = res.json();
        const status = res.status;
        const errors = response.errors;
        // Toggle loading flag
        this.isLoading = false;
        // Parse backend errors
        if (status === 422) {
          this.formErrors = FormUtils.parseBackendErrors(this.resetForm, this.formErrors, errors);
        } else {
          // Show message
          this.toastr.error('No es posible realizar esta acción.', 'Error!');
        }
      }
    );
  }

  /**
   * Create reset password form group and controls
   */
  private buildForm(): void {
    this.resetForm = this.fb.group({
      'password': ['', Validators.required],
      'confirmPassword': ['', [Validators.required, WoopaValidators.equalsTo('password')]]
    });
    this.resetForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    // (re)set validation messages now
    this.onValueChanged();
  }

  /**
   * Handles object value changes.
   * @param _data Data
   */
  private onValueChanged(_data?: any) {
    if (!this.resetForm) {
      return;
    }
    // Clear backend errors
    this.errors = [];
    // Parse form errors
    this.formErrors = FormUtils.parseErrors(this.resetForm, this.formErrors, this.validationMessages);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/public/reset/reset.component.ts